import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import LinkIcon from "@atlaskit/icon/glyph/editor/link";
import { TextField } from "../../Styled/atlaskitComponents";

import { PrimaryButton } from "./styled/Components";
import { useTheme } from "styled-components";
import { urlValidator } from "../../../../helpers/validators";
function DirectLink({ value, setValue }) {
  const [input, setInput] = useState("");

  const theme = useTheme();

  useEffect(() => {
    if (value?.source && value?.source === "direct") {
      setInput(value.link);
    } else if (typeof value === "string" && urlValidator({ url: value })) {
      setInput(value);
    }
  }, [value]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px",
      }}
    >
      <div style={{ width: "100%" }}>
        <TextField
          elemBeforeInput={
            <LinkIcon size="medium" primaryColor={theme.global.text.dark} />
          }
          placeholder="google.com"
          name="direct-link"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>

      <PrimaryButton
        onClick={() => {
          if (!input.trim()) {
            return setValue("");
          }

          const formattedInput = input.trim().startsWith("http")
            ? input.trim()
            : `https://${input.trim()}`;

          urlValidator({ url: formattedInput }) &&
            setValue({ link: formattedInput, source: "direct" });
        }}
      >
        Set as link
      </PrimaryButton>
    </div>
  );
}

DirectLink.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  setValue: PropTypes.func.isRequired,
};

export default DirectLink;
